import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '比赛ID',
      prop: 'matchId'
    },
    {
      label: '比赛名称',
      prop: 'matchName'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '比赛类型',
      prop: 'matchType'
    },
    {
      label: '签位',
      prop: 'signNo'
    },
    {
      label: '比赛级别',
      prop: 'matchLevel'
    },
    {
      label: '比赛时间',
      prop: 'matchStartTime'
    },
    {
      label: '裁判',
      prop: 'referee'
    },
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '级别',
      prop: 'memberLevel'
    },
    {
      label: '积分',
      prop: 'score'
    },
    {
      label: '会员类型',
      prop: 'type'
    }
  ]
}
